import set from "lodash/set";

export function reducedErrorsFromResponse(errors) {
  return errors.reduce(
    (errs, { attribute, message }) => set(errs, attribute, message),
    {}
  );
}
